/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Archivage
 * 1 = AppelTel
 * 2 = CourrierSensibilisation
 * 3 = CourrierAvertissement
 * 4 = CourrierExclusionTemporaire
 * 5 = CourrierExclusionDefinitive
 * 6 = VisionnageCamera
 * 7 = DepotPlainte
 * 8 = Assurance
 * 9 = Reparation
 * 10 = Communication
 * 11 = Autres
 */
export enum TypeActionCorrectiveRapportIncident {
  Archivage = 0,
  AppelTel = 1,
  CourrierSensibilisation = 2,
  CourrierAvertissement = 3,
  CourrierExclusionTemporaire = 4,
  CourrierExclusionDefinitive = 5,
  VisionnageCamera = 6,
  DepotPlainte = 7,
  Assurance = 8,
  Reparation = 9,
  Communication = 10,
  Autres = 11
}
